import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import React, { useState, useEffect } from "react";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import DateRangeIcon from "@mui/icons-material/DateRange";
import QuizIcon from "@mui/icons-material/Quiz";
import ArrowForward from "@mui/icons-material/ArrowForward";
import LibraryAddCheckIcon from "@mui/icons-material/LibraryAddCheck";

import useCrew from "../../hooks/useCrew";
import useUser from "../../hooks/useUser";
import Button from "../../components/Button";
import TableComponent from "../../components/TableComponent";
import { getTrainings } from "../../api/training.deprecated";
import { convertDateTime } from "../../services/formatters";
import { OkIcon, ExpiredIcon } from "../../components/CourseStatusIcon";

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

const TrainerTrainings = ({ match, history }) => {
  const { t } = useTranslation();
  const [trainings, setTrainings] = useState([]);
  const user = useUser();
  const { crew } = useCrew();
  const eventType = "trainer";

  useEffect(() => {
    (async () => {
      console.log("user.id");

      const res = await getTrainings();
      console.log("res", res);
      setTrainings(res);
    })();
  }, []);

  return (
    <>
      <Typography variant="h4">{t("training_pages.trainings_list")}</Typography>

      {trainings ? (
        <TableComponent
          header={[
            { title: t("id"), style: { width: "5%" } },
            { title: t("course_id"), style: { width: "5%" } },
            { title: t("training_pages.training") },

            { title: t("status") },
            { title: t("training_pages.e_learning") },
            { title: t("training_pages.classroom") },
            { title: t("training_pages.practical") },

            { title: t("actions") },
          ]}
          renderChildren={(training) => (
            <TableRow key={training.id}>
              <TableCell>{training.id}</TableCell>
              <TableCell>{training.courseId}</TableCell>
              <TableCell>{training.displayname}</TableCell>

              <TableCell>{training.status}</TableCell>

              <TableCell>{training.isELearning ? <OkIcon /> : <ExpiredIcon />}</TableCell>

              <TableCell>{training.isClassroom ? <OkIcon /> : <ExpiredIcon />}</TableCell>

              <TableCell>{training.isPractical ? <OkIcon /> : <ExpiredIcon />}</TableCell>

              <TableCell>
                <Button
                  icon={<ArrowForward />}
                  onClick={() => history.push(`/training-users/user/${training.id}`)}
                  title={t("training_pages.users_list")}
                />
              </TableCell>
            </TableRow>
          )}
          search={["displayname", "id", "courseId"]}
          pagination
          items={trainings}
        />
      ) : null}
    </>
  );
};

export default TrainerTrainings;
